/**
 * @generated SignedSource<<fa814279ac7b28adfe959508a31d878e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickViewCreators_quickViewDisplay$data = {
  readonly creators: ReadonlyArray<{
    readonly displayName: string;
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
  } | null> | null;
  readonly " $fragmentType": "QuickViewCreators_quickViewDisplay";
};
export type QuickViewCreators_quickViewDisplay$key = {
  readonly " $data"?: QuickViewCreators_quickViewDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCreators_quickViewDisplay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCreators_quickViewDisplay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuickViewDisplayType",
  "abstractKey": null
};

(node as any).hash = "ae92a3cd076ee92647c1154cf1c7e512";

export default node;
